import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/sys/user/uc/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/sys/info',
    method: 'get',
    params: {
      token
    }
  })
}
export function getUserInfo(data) {
  return request({
    url: '/sys/user/detial',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/sys/user/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCode(data) {
  return request({
    url: '/sys/code',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}
// 上传图片
export function uploadImg(data) {
  return request({
    url: '/file/upload',
    method: 'post',
    data
  })
}

// 获取token

export function getToken(data) {
  return request({
    url: '/qiniu/token',
    method: 'post',
    data
  })
}
// 将视频上传到后端服务
export function uploadSever(data) {
  return request({
    url: '/qiniu/upload',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js